module.exports = __webpack_public_path__ + "media/components/page-header/static/icon-user--grey-3aed5e5e598b0cd6233eba5261d2e625.svg";